import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconVerticalAlignmentRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconVerticalAlignmentRight"><Path d="M20.5 3.5V20.5" stroke="currentColor" strokeLinecap="square"/><Path d="M17.5 6.5H3.5V10.5H17.5V6.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M17.5 13.5H7.5V17.5H17.5V13.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconVerticalAlignmentRight;
